import { render, staticRenderFns } from "../templates/normal_fcont_146.html?vue&type=template&id=3aaf7948&scoped=true&"
import script from "./normal_fcont_146.vue?vue&type=script&lang=js&"
export * from "./normal_fcont_146.vue?vue&type=script&lang=js&"
import style0 from "./normal_fcont_146.vue?vue&type=style&index=0&id=3aaf7948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaf7948",
  null
  
)

export default component.exports